<template>
  <div class="form-group my-3" :class="{'has-error' : error}" >
    <div class="row g-3">
      <label
        :id="for_label_comp + '_label'"
        v-if="label"
        :for="for_label_comp"
        :class="[labelWidthClass, required ? 'is-required' : '']"
      >
        <slot name="label">{{ label }}</slot>
        <span v-if="aria" class="sr-only">{{aria}}</span>
      </label>

      <div v-if="!label" :class="labelWidthClass"></div>
      <div :class="controlWidthClass">
        <slot/>
        <p
          class="error"
          v-if="error"
          :title="error"
          :id="for_label_comp + '_label'"
          v-html="error.toString()"
        ></p>
      </div>
      <div :class="descriptionWidthClass">
        <div class="form-control-description"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IcFormRowHorizontal",
  props: {
    error: {
      type: [String, Object, Boolean],
      required: false
    },
    label: {
      type: String,
      required: false
    },
    new_id: {
      type: String,
      required: false
    },
    labelWidth: {
      type: Number,
      default: 3
    },
    controlWidth: {
      type: Number,
      default: 5
    },
    required: {
      type: Boolean,
      default: false
    },
    aria: {
      type: String,
      default: ""
    },
    for_label: {
      type: String,
      required: false
    },    
  },
  data() {
    return {
      for_label_comp: ''
    }
  },    
  mounted: function(){
    if(!this.$attrs.id && this.new_id) this.$attrs.id = this.new_id;
    this.$el.id = this.id+"_parent";
  },
  updated: function(){
    if(!this.$attrs.id && this.new_id) this.$attrs.id = this.new_id;
    if(!this.for_label) this.for_label_comp = this.$attrs.id; else this.for_label_comp = this.for_label;
  },
  created: function(){
    if(!this.$attrs.id && this.new_id) this.$attrs.id = this.new_id;
    if(!this.for_label) this.for_label_comp = this.$attrs.id; else this.for_label_comp = this.for_label;
  },
  computed: {
    labelWidthClass() {
      return this.labelWidth == 0
        ? "hide"
        : "col-12 col-sm-" + this.labelWidth + " control-label control-label-medium";
    },
    controlWidthClass() {
      return "col-sm-" + this.controlWidth;
    },
    descriptionWidthClass() {
      return "col-auto col-sm-" + (12 - this.labelWidth - this.controlWidth);
    }
  }
};
</script>

<style>
</style>